export default {
  arrivalsTotalAmount(state) {
    return Math.max(...state.arrivals.map(arrival => arrival.amount));
  },
};



// WEBPACK FOOTER //
// ./src/features/private/dashboard/dashboards/sc-dashboard-shipment-deliver/store/getters.js